/**
 * "Not now" hides that same paywall for the rest of the browser session. The key is the trigger
 * number when the server sent one, else the metric. sessionStorage holds it; a memory set stands in
 * where storage is blocked.
 */
const PREFIX = "nira.paywall.dismissed."
const memory = new Set<string>()

export const paywallKey = (d: { trigger?: number | null; metric: string }): string => String(d.trigger ?? d.metric)

export function isDismissed(key: string): boolean {
  if (memory.has(key)) return true
  try {
    return window.sessionStorage.getItem(PREFIX + key) === "1"
  } catch {
    return false
  }
}

export function dismiss(key: string): void {
  memory.add(key)
  try {
    window.sessionStorage.setItem(PREFIX + key, "1")
  } catch {
    /* memory only */
  }
}

/** Forget every dismissal (tests, sign-out). */
export function resetDismissed(): void {
  memory.clear()
  try {
    const drop: string[] = []
    for (let i = 0; i < window.sessionStorage.length; i++) {
      const k = window.sessionStorage.key(i)
      if (k?.startsWith(PREFIX)) drop.push(k)
    }
    drop.forEach((k) => window.sessionStorage.removeItem(k))
  } catch {
    /* nothing stored */
  }
}
